/*
  Pure duration formatters, deliberately kept out of TimerProvider: that module is `'use client'`, which
  turns every one of its exports into a client reference, and a server component that imports one gets
  "Attempted to call formatTimeShort() from the server" at render time rather than a build error.
*/

const fmt = (count: number, what: string) => `${count} ${count === 1 ? what : `${what}s`}`;

export const formatTime = (totalSeconds: number): string => {
  if (totalSeconds >= 86400) {
    // Over 24 hours (24 * 60 * 60)
    const days = Math.floor(totalSeconds / 86400);
    const remainingHours = Math.floor((totalSeconds % 86400) / 3600);
    return `${fmt(days, 'day')} ${fmt(remainingHours, 'hour')}`;
  } else if (totalSeconds >= 3600) {
    // Over an hour
    return `${fmt(Math.floor(totalSeconds / 3600), 'hour')} ${fmt(Math.floor((totalSeconds % 3600) / 60), 'minute')}`;
  } else if (totalSeconds >= 900) {
    // Over 15 minutes
    return `${fmt(Math.floor(totalSeconds / 60), 'minute')}`;
  } else {
    // Under 15 minutes
    return `${fmt(Math.floor(totalSeconds / 60), 'minute')} ${fmt(totalSeconds % 60, 'second')}`;
  }
};

export const formatTimeShort = (totalSeconds: number): string => {
  const mins = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};
